import { render, staticRenderFns } from "./VisualizarContratos.vue?vue&type=template&id=2769f916&"
import script from "./VisualizarContratos.vue?vue&type=script&lang=js&"
export * from "./VisualizarContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports